import { render, staticRenderFns } from "./TranHistoryPage.vue?vue&type=template&id=3ab971b8&scoped=true&"
import script from "./TranHistoryPage.vue?vue&type=script&lang=js&"
export * from "./TranHistoryPage.vue?vue&type=script&lang=js&"
import style0 from "./TranHistoryPage.vue?vue&type=style&index=0&id=3ab971b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab971b8",
  null
  
)

export default component.exports